import { Report } from "interfaces";
import { Divider } from "primereact/divider";

import { ReportAnswerContainer } from "./ReportAnswerContainer";
import { ReportQuestionContainer } from "./ReportQuestionContainer";

export const ReportDetailPanelBody = ({ report }: { report: Report }) => {
  return (
    <div className="padd-left-18 padd-right-18 padd-bottom-18 report-container">
      {report.description && report.description?.length > 0 && (
        <div className="description-container italic break-word">
          “{report.description}“
        </div>
      )}
      <Divider className="top-divider" />
      {report.answer?.question && (
        <ReportQuestionContainer
          question={report.answer?.question}
          repliedAnswer={report.answer.repliedAnswer}
        />
      )}
      {report.answer && <ReportAnswerContainer answer={report.answer} />}
    </div>
  );
};
